<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="类型" prop="type">
<!--      <dict-select v-model="form.data.type" dict-code="INDEX_POSTER_TYPE"/>-->
<!--      <a-input v-model="form.data.type"/>-->
      <a-select v-model="form.data.type" placeholder="请选择">-->
        <a-select-option
          v-for="item in size.data"
          :key="item.id"
          :title="item.type"
          :value="item.type+','+item.id"
          @click="querySizeTip(item.id)"
        >
          {{ item.type }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="图片" >
      <div class="a-input">
        <simple-uploader v-model="form.data.coverPath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!sizeId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="sizeId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryGoodsSize,
  _addGoodsSize,
  _updateGoodsSize,
} from '@/api/goodsSizeApi';
import {
  _querySizeTips,
} from '@/api/appInfoDetailApi';
import { _querySizeTip } from '@/api/appInfoDetailApi';
import SimpleUploader from '@/components/SimpleUploader.vue';

async function getInspiration() {
  const result = await _queryGoodsSize(this.sizeId);
  if (result) {
    this.form.data.sizeTipId = result.sizeTipId;
    this.form.data.type = result.type;
    this.form.data.coverPath = result.coverPath;
  }
}
async function querySizeTip(sizeId) {
  console.log(sizeId);
  const result = await _querySizeTips(sizeId);
  this.form.data.coverPath = result.coverPath;
}

async function onAdd() {
  const res = this.form.data.type.split(',');
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsSize({
        type: res[0],
        coverPath: this.form.data.coverPath,
        goodsId: this.goodsId,
        sizeTipId: res[1],
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsSize(this.sizeId, {
        type: this.form.data.type,
        coverPath: this.form.data.coverPath,
        goodsId: this.goodsId,
        sizeTipId: this.form.data.sizeTipId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsSizeEdit',
  components: {
    SimpleUploader,
  },
  props: {
    sizeId: String,
    goodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    sizeId() {
      if (this.sizeId) {
        this.getInspiration();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getInspiration,
    querySizeTip,
  },
  data() {
    return {
      size: {
        data: [],
      },
      form: {
        data: {
          type: '',
          coverPath: '',
          sizeTipId: '',
        },
        rules: {
          // name: [{ required: true, trigger: 'blur' }],
          // nameEn: [{ required: true, trigger: 'blur' }],
          // coverPath: [{ required: true, trigger: 'blur' }],
          // isVip: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  async created() {
    const result = await _querySizeTip({});
    this.size.data = result.content;
    if (this.sizeId) {
      await this.getInspiration();
    }
  },
};
</script>
